import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const key = (id) => `wardogs_last_matches_${id}`;

// Polls the signed-in linked member's match count and pops a celebratory toast
// the first time (and every time) a completed live round is credited to them.
const LiveCreditWatcher = () => {
  const { user, refresh } = useAuth();
  const timer = useRef(null);

  useEffect(() => {
    if (!user || !user.id || !user.steam_id) return;
    // Seed baseline from current stats so we never toast for pre-existing matches.
    if (localStorage.getItem(key(user.id)) === null) {
      localStorage.setItem(key(user.id), String(user.stats?.matches ?? 0));
    }
    const poll = async () => {
      try {
        const { data } = await api.get("/auth/me");
        const cur = data.stats?.matches ?? 0;
        const prev = parseInt(localStorage.getItem(key(user.id)) ?? String(cur), 10);
        if (cur > prev) {
          const gained = cur - prev;
          toast.success(
            prev === 0
              ? "🎖️ First round credited! Your combat stats are now live."
              : `⚔️ Round credited — ${gained} new match${gained > 1 ? "es" : ""} on your profile.`,
            { duration: 9000, description: "Nice work, operator. Keep fragging." }
          );
          localStorage.setItem(key(user.id), String(cur));
          refresh?.();
        } else if (cur !== prev) {
          localStorage.setItem(key(user.id), String(cur));
        }
      } catch { /* ignore transient errors */ }
      // Seeder whitelist grant toast
      try {
        const { data } = await api.get("/seed/my-status");
        const wlKey = `wardogs_wl_exp_${user.id}`;
        const seen = localStorage.getItem(wlKey);
        if (data.active && data.source !== "staff" && data.expires_at && data.expires_at !== seen) {
          if (seen !== null) {
            toast.success("🌱 Seeder reward earned!", {
              duration: 10000,
              description: `You've got ${data.days_left <= 0 ? "3" : data.days_left} days of reserved-slot whitelist access — join even when the server's full.`,
            });
          }
          localStorage.setItem(wlKey, data.expires_at);
        } else if (!data.active && seen) {
          localStorage.removeItem(wlKey);
        }
      } catch { /* ignore */ }
    };
    timer.current = setInterval(poll, 30000);
    return () => clearInterval(timer.current);
  }, [user, refresh]);

  return null;
};

export default LiveCreditWatcher;
